import axiosInstance from './axiosInstance';

export const getSummary    = ()              => axiosInstance.get('analytics/creator/summary/');
export const getPosts      = (page, sort)    => axiosInstance.get('analytics/creator/posts/',      { params: { page, sort } });
export const getLinks      = ()              => axiosInstance.get('analytics/creator/links/');
export const getTimeseries = (days = 30)     => axiosInstance.get('analytics/creator/timeseries/', { params: { days } });
